const SummaryCard = ({
    label,
    value,
    sublabel,
    FontSize,
    color,
    highlight = false
}) => {
    const colorClasses = {
        blue: "bg-primary-subtle text-primary border-primary",
        indigo: "bg-info-subtle text-info border-info",
        emerald: "bg-success-subtle text-success border-success",
        amber: "bg-warning-subtle text-warning border-warning",
        green: "bg-success-subtle text-success border-success"
    };

    const css = colorClasses[color] || colorClasses.blue;

    return (
        <div
            className={`p-3 rounded-4 border shadow-sm h-100 d-flex flex-column justify-content-between ${FontSize}  ${highlight ? "border-3 border-success" : "bg-white"
                } ${css}`}
            style={highlight ? { boxShadow: "0 0 0 3px rgba(25,135,84,.25)" } : {}}
        >
            <div>
                <div className="text-muted text-uppercase small fw-semibold mb-1">
                    {label}
                </div>

                <div
                    className={`fs-4 fw-bold font-size ${highlight ? "text-success" : "text-dark"
                        }`}
                >
                    {value}
                </div>
            </div>

            {sublabel && (
                <div className="mt-2 pt-2 border-top small text-muted">
                    {sublabel}
                </div>
            )}
        </div>
    );
};
export default SummaryCard;